import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import { User } from "@phoenixlan/phoenix.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight }  from '@fortawesome/free-solid-svg-icons'
import { Notice } from "../../components/containers/notice";
import { PageLoading } from "../../components/pageLoading"
import { Table, SelectableTableRow, TableCell, TableHead, IconContainer, TableBody, TableRow } from "../../components/table";
import { useUserSearch } from "../../hooks/useUserSearch";
import { dateOfBirthToAge } from '../../utils/user';
import { DashboardHeader, DashboardContent, DashboardTitle, DashboardSubtitle, InnerContainer, InputCheckbox, SpanLink, InnerContainerRow, InputContainer, InputLabel, InputSelect, InputElement, CardContainer } from "../../components/dashboard";

const SORTING_METHODS = {
    FIRSTNAME: 1,
    USERNAME: 2,
    AGE: 3,
    CREATED: 4
}

const SORTING_TYPES = {}
SORTING_TYPES[SORTING_METHODS.FIRSTNAME] = (a, b) => a.firstname.localeCompare(b.firstname);
SORTING_TYPES[SORTING_METHODS.USERNAME] = (a, b) => a.username.localeCompare(b.username);
SORTING_TYPES[SORTING_METHODS.CREATED] = (a, b) => a.created - b.created;
SORTING_TYPES[SORTING_METHODS.AGE] = (a, b) => dateOfBirthToAge(a.birthdate) - dateOfBirthToAge(b.birthdate);

export const UserSearch = () => {
    const [activeSortingMethod, setActiveSortingMethod] = useState(1);
    const [search, setSearch] = useState("");
    const [visibleUUID, setVisibleUUID] = useState(false);

    let history = useHistory();

    const { data: users, loading } = useUserSearch(search);

    if(loading) {
        return (<PageLoading />)
    }

    let processedUserList = users??[]
    .sort(SORTING_TYPES[activeSortingMethod])

    return (
        <>
            <DashboardHeader border>
                <DashboardTitle>
                    Søk i brukere
                </DashboardTitle>
                <DashboardSubtitle>
                    { "Viser " + processedUserList.length + " brukere" }
                </DashboardSubtitle>
            </DashboardHeader>
            <DashboardContent>
                <InnerContainer>
                    <InnerContainerRow>
                        <Notice fillWidth type="info" visible={true}>
                            <p>Hvorfor kan jeg ikke se alle brukerne?</p>
                            <p>Phoenix-systemet lar deg kun hente ut lister over brukere som er aktivt involvert i nåværende arrangementer. Dette betyr at dersom noen deltok på et arrangement for et par år siden er de i praksis ikke innvolvert med oss, fram til de selv velger å delta igjen.</p>
                            <p>Søkemuligheten gir spesielt tillitsvalgte administratorer mulighet til å hente informasjon om gamle brukere de har kjennskap til, skulle dette være nødvendig for kundestøtte eller andre grunner.</p>
                            <p>Merk: Systemet viser max 10 brukere om gangen, og du må søke med minst 4 tegn. Dette for å gjøre det vanskelig å bruke søkefunksjonen for å hente ut brukerlisten.</p>

                            <p>Les mer <a href="https://www.datatilsynet.no/rettigheter-og-plikter/virksomhetenes-plikter/">her</a></p>
                        </Notice>
                    </InnerContainerRow>
                </InnerContainer>
                <InnerContainer>
                    <InnerContainerRow>
                        <InnerContainer flex="1">
                            <CardContainer>
                                <InputContainer column extramargin>
                                    <InputLabel small>Søk</InputLabel>
                                    <InputElement type="text" placeholder="For- etternavn, e-post, telefon nummer ..." onChange={(e) => setSearch(e.target.value.toLowerCase())}></InputElement>
                                </InputContainer>
                            </CardContainer>
                            
                            <CardContainer>
                                <InputContainer column extramargin>
                                    <InputLabel small>Sortering</InputLabel>
                                    <InputSelect onChange={(e) => setActiveSortingMethod(e.target.value)}>
                                        <option value={SORTING_METHODS.FIRSTNAME}>Fornavn</option>
                                        <option value={SORTING_METHODS.USERNAME}>Brukernavn</option>
                                        <option value={SORTING_METHODS.AGE}>Alder</option>
                                        <option value={SORTING_METHODS.CREATED}>Registrert</option>
                                    </InputSelect>
                                </InputContainer>
                            </CardContainer>
                        </InnerContainer>
                        <InnerContainer flex="2" />
                    </InnerContainerRow>
                </InnerContainer>

                <InnerContainer>
                    <Table>
                        <TableHead border>
                            <TableRow>
                                <TableCell as="th" flex="5" visible={!visibleUUID}>UUID <SpanLink onClick={() => setVisibleUUID(!visibleUUID)}>{visibleUUID ? "(Skjul UUID)" : null}</SpanLink></TableCell>
                                <TableCell as="th" flex="3" mobileFlex="3">Navn <SpanLink mobileHide onClick={() => setVisibleUUID(!visibleUUID)}>{visibleUUID ? null : "(Vis UUID)"}</SpanLink></TableCell>
                                <TableCell as="th" flex="1" mobileFlex="1">Alder</TableCell>
                                <TableCell as="th" flex="2" mobileHide>Brukernavn</TableCell>
                                <TableCell as="th" flex="3" mobileHide>Registrert</TableCell>
                                <TableCell as="th" flex="0 24px" mobileHide/>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                processedUserList.map((user) => {
                                    return (
                                        <SelectableTableRow onClick={e => {history.push(`/user/${user.uuid}`)}} title="Trykk for å åpne" key={user.uuid}>
                                            <TableCell consolas flex="5" visible={!visibleUUID} mobileHide>{ user.uuid }</TableCell>
                                            <TableCell flex="3" mobileFlex="3">{ user.firstname + " " + user.lastname }</TableCell>
                                            <TableCell flex="1" mobileFlex="1">{dateOfBirthToAge(user.birthdate)}</TableCell>
                                            <TableCell flex="2" mobileHide>{ user.username }</TableCell>
                                            <TableCell flex="3" mobileHide>{ new Date(user.created*1000).toLocaleString('no-NO', {hour: '2-digit', minute: '2-digit', year: '2-digit', month: '2-digit', day: '2-digit'}) }</TableCell>
                                            <TableCell flex="0 24px" mobileHide><IconContainer><FontAwesomeIcon icon={faArrowRight}/></IconContainer></TableCell>
                                        </SelectableTableRow>
                                    )
                                }
                            )}
                        </TableBody>
                    </Table>
                </InnerContainer>
            </DashboardContent>
        </>
    )
}
